import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import DisplaySelectedPopup from "../components/Charts/DisplaySelectedPopup";
import AtomsGauge from "./AutodisplayView/components/atoms/AtomsGauge";
import MoleculeModeFloating from "./Global/components/molecules/MoleculeModeFloating";
import MoleculeSizeArea from "./Global/components/molecules/MoleculeSizeArea";

const ComponentTest = () => {
  const navigate = useNavigate();
  const [isDisplayPopupOpen, setIsDisplayPopupOpen] = useState(false);
  
  // 게이지 테스트용 상태값들
  const [tempValue, setTempValue] = useState(23);
  const [humidityValue, setHumidityValue] = useState(44);
  const [vocValue, setVocValue] = useState(85);
  const [co2Value, setCo2Value] = useState(720);

  // 테스트할 컴포넌트 링크 목록
  const componentLinks = [
    {
      name: 'AtomsGauge',
      description: '동적 게이지 컴포넌트 - 실시간 값 변경 테스트',
      path: '/atoms-gauge-test'
    },
    {
      name: 'MoleculeTemplateCard',
      description: '템플릿 카드 컴포넌트',
      path: '/CreateContent'
    },
    {
      name: 'OrganismDesignConceptSelector', 
      description: '디자인 컨셉트 선택기',
      path: '/CreateContent'
    },
    {
      name: 'MoleculeAnalysisCard',
      description: '분석 카드 컴포넌트', 
      path: '/CreateContent'
    }
  ];

  const handleModeChange = (mode) => {
    console.log('선택된 모드:', mode);
  };

  return (
    <Container>
      <Header>
        <Title>컴포넌트 테스트 페이지</Title>
        <Description>개발한 컴포넌트들을 테스트할 수 있는 페이지입니다.</Description>
      </Header>

      <ComponentList>
        {componentLinks.map((component, index) => (
          <ComponentItem key={index}>
            <ComponentInfo>
              <ComponentName>{component.name}</ComponentName>
              <ComponentDesc>{component.description}</ComponentDesc>
            </ComponentInfo>
            <TestButton onClick={() => navigate(component.path)}>
              테스트하기
            </TestButton>
          </ComponentItem>
        ))}
        
        {/* DisplaySelectedPopup 직접 테스트 */}
        <ComponentItem>
          <ComponentInfo>
            <ComponentName>DisplaySelectedPopup</ComponentName>
            <ComponentDesc>디스플레이 선택 팝업 (이 페이지에서 직접 테스트)</ComponentDesc>
          </ComponentInfo>
          <TestButton onClick={() => setIsDisplayPopupOpen(true)}>
            팝업 열기
          </TestButton>
        </ComponentItem>
      </ComponentList>

      {/* MoleculeModeFloating 직접 테스트 */}
      <TestSection>
        <TestTitle>MoleculeModeFloating 컴포넌트 테스트</TestTitle>
        <TestDescription>
          피그마 디자인을 바탕으로 만든 디스플레이 모드 선택 컴포넌트입니다.
        </TestDescription>
        <ComponentWrapper>
          <MoleculeModeFloating onModeChange={handleModeChange} />
        </ComponentWrapper>
      </TestSection>

      {/* MoleculeSizeArea 직접 테스트 */}
      <TestSection>
        <TestTitle>MoleculeSizeArea 컴포넌트 테스트</TestTitle>
        <TestDescription>
          콘텐츠 요소의 사이즈를 표시하는 영역 컴포넌트입니다. 상단 제목 영역 바로 아래에 붙어서 포스터 및 여러 콘텐츠 요소의 사이즈를 알려줍니다.
        </TestDescription>
        <SizeAreaWrapper>
          <MoleculeSizeArea />
          <SizeAreaSpacer />
          <MoleculeSizeArea title="화면 자동맞춤" width="1366" height="768" />
          <SizeAreaSpacer />
          <MoleculeSizeArea title="모바일 디스플레이" width="375" height="812" />
        </SizeAreaWrapper>
      </TestSection>



      <AddSection>
        <AddTitle>새 컴포넌트 추가하기</AddTitle>
        <AddDescription>
          componentLinks 배열에 새로운 객체를 추가하여 테스트할 컴포넌트를 등록할 수 있습니다.
        </AddDescription>
        <CodeExample>
          {`{
  name: '컴포넌트명',
  description: '컴포넌트 설명',
  path: '/라우트경로'
}`}
        </CodeExample>
      </AddSection>

      {/* DisplaySelectedPopup 렌더링 */}
      {isDisplayPopupOpen && (
        <DisplaySelectedPopup
          onClose={() => setIsDisplayPopupOpen(false)}
        />
      )}
    </Container>
  );
};

export default ComponentTest;

const Container = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 40px;
  font-family: Pretendard, sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding: 32px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #131416;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #464C53;
  line-height: 1.5;
`;

const ComponentList = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const ComponentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #E0E4EB;
  border-radius: 8px;
  margin-bottom: 16px;
  transition: all 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: #256EF4;
    background: rgba(37, 110, 244, 0.02);
  }
`;

const ComponentInfo = styled.div`
  flex: 1;
`;

const ComponentName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #131416;
  margin-bottom: 4px;
`;

const ComponentDesc = styled.div`
  font-size: 14px;
  color: #464C53;
`;

const TestButton = styled.button`
  background: #256EF4;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #1e5bdb;
  }
`;

const AddSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const TestSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const TestTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #131416;
  margin-bottom: 8px;
`;

const TestDescription = styled.p`
  font-size: 14px;
  color: #464C53;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const ComponentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 180px 40px 40px 40px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #E0E4EB;
  overflow-x: auto;
  min-width: 732px;
  position: relative;
`;

const SizeAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #E0E4EB;
  overflow: hidden;
`;

const SizeAreaSpacer = styled.div`
  height: 16px;
  background: #f8f9fa;
`;

const AddTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #131416;
  margin-bottom: 12px;
`;

const AddDescription = styled.p`
  font-size: 14px;
  color: #464C53;
  line-height: 1.5;
  margin-bottom: 16px;
`;

const CodeExample = styled.pre`
  background: #f6f8fa;
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  padding: 16px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 13px;
  color: #24292e;
  overflow-x: auto;
`; 